<template>
    <div class="row">
      <div class="col-md-12 text-center">
        <p>Are you sure you want to archive <strong>{{ data.name }}</strong>?</p>
        <button @click="archiveDeployment" class="btn btn-fill btn-info btn-wd btn-danger">Archive</button>
      </div>
    </div>
</template>

<script>
  import Constants from 'src/utilities/constants'
  import {notifySuccess} from 'src/utilities/utils'

  export default {
    props: ['data'],
    methods: {
      async archiveDeployment() {
        const response = await this.$store.dispatch('camunda/archiveDeployment', this.data)

        if (response.result === Constants.RETURN_CODES.SUCCESS) {
          notifySuccess(this, this.data.name + ' archived successfully')
          this.$eventHub.$emit('camundaDeploymentArchived')
          this.$emit('close')
        }
      }
    }
  }
</script>
